export function apiUrl(path: string) {
    return `${process.env.REACT_APP_DIAGNOSTICS_API_PREFIX}${path}`
}